export enum AddressBookInformationTypeEnum {
    PHONE = 'phone',
    EMAIL = 'email',
    ADDRESS = 'address',
    URL = 'url',
    ICO = 'ico',
    DIC = 'dic',
    IC_DPH = 'icDph',
    ICP = 'icp',
}

export const addressBookJsonInformations = [
    AddressBookInformationTypeEnum.ADDRESS,
] as string[];
